import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    height: 'auto',
    width: '100%',
    maxWidth: '19.5rem',
    padding: '1.5rem',
    gap: '2rem',

    [theme.breakpoints.up('sm')]: {
      maxWidth: '25rem',
    },
  },
}));

export const Content = styled('div')({
  display: 'flex',
  color: theme.palette.common.white,
  flexDirection: 'column',
  gap: '1.5rem',
});

export const CloseBox = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const CloseIconStyled = styled(CloseIcon)({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
});

export const FileContainer = styled('div')<{ hasFile?: boolean }>(({ theme, hasFile }) => ({
  color: theme.palette.common.white,
  display: 'flex',
  flexDirection: hasFile ? 'row' : 'column',
  border: `0.1rem dashed ${theme.palette.common.white}`,
  padding: '1rem',
  textAlign: 'center',
  borderRadius: '0.5rem',
  gap: '2rem',
  alignItems: hasFile ? 'center' : 'initial',
  justifyContent: hasFile ? 'space-between' : 'initial',
  backgroundColor: 'transparent',
}));

export const AlignButtons = styled('div')({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
});

export const StoreListContainer = styled('div')({
  maxHeight: '15rem',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  paddingLeft: '0.5rem',
  border: `0.063rem solid ${theme.palette.secondary.main}`,

  borderRadius: '0.5rem',
});
